export default "__VITE_ASSET__CNBF56i9__"